<template>
    <div class="resume">
      <div class="resume-info-content-box">
        <div class="resume-header">
          <span>最后更新时间</span>&nbsp;&nbsp;<span>{{baseInfo.updateDate | dateFormat("YYYY-MM-DD hh:mm:ss")}}</span>
          <span class="download-resume" @click="downloadMyResume()">下载个人简历</span>
        </div>

<!--        个人信息-->
        <div class="base-info" v-if="!baseInfo.isEditBaseInfo">
          <div class="user-name">{{baseInfo.name}}&nbsp;<i :class="{'el-icon-male': baseInfo.sex === '01', 'el-icon-female': baseInfo.sex === '02'}"></i></div>
          <div class="base-info-content">
            <div style="margin-top: 10px">
              <span class="base-info-item"><i class="el-icon-monitor"></i> {{baseInfo.workExperience}} 年</span>
              <span class="base-info-item line-divide"><i class="el-icon-medal"></i> {{baseInfo.education}} 学历</span>
              <span class="base-info-item line-divide"><i class="el-icon-user"></i> {{baseInfo.workState}}</span>
            </div>
            <div style="margin-top: 10px">
              <span class="base-info-item"><i class="el-icon-mobile-phone"></i> {{baseInfo.phoneNumber}}</span>
              <span class="base-info-item"></span>
            </div>
          </div>
          <div class="edit" @click="baseInfo.isEditBaseInfo = true"><i class="el-icon-edit-outline"></i> 编辑</div>
        </div>
        <div class="base-info-edit" v-else>
          <div class="edit-title">编辑个人信息</div>
          <el-form :inline="true" :model="baseInfo" size="small" :label-position="'left'" :label-width="'100px'" class="edit-info-form">
            <!--<el-form-item label="姓名">
              <el-input v-model="baseInfo.name" placeholder="请输入您的姓名"></el-input>
            </el-form-item>-->
            <el-form-item label="当前求职状态">
              <el-select v-model="baseInfo.workState" placeholder="当前求职状态">
                <el-option label="离职-随时到岗" value="离职-随时到岗"></el-option>
                <el-option label="在职-暂不考虑" value="在职-暂不考虑"></el-option>
                <el-option label="在职-考虑机会" value="在职-考虑机会"></el-option>
                <el-option label="在职-月内到岗" value="在职-月内到岗"></el-option>
              </el-select>
            </el-form-item>
            <!--<el-form-item label="性别" class="sex-radio">
              <el-button @click="baseInfo.sex = '01'" style="width: calc(50% - 7px);" :class="{'btn-checked': baseInfo.sex === '01'}">男</el-button>
              <el-button @click="baseInfo.sex = '02'" style="width: calc(50% - 7px);" :class="{'btn-checked': baseInfo.sex === '02'}">女</el-button>
            </el-form-item>-->
            <el-form-item label="工作年限">
<!--              <el-input v-model="baseInfo.workExperience" placeholder="请输入您的工年限"></el-input>-->
              <el-input-number v-model="baseInfo.workExperience" :min="0" :max="60"></el-input-number>
            </el-form-item>
            <el-form-item label="手机号">
              <el-input v-model="baseInfo.phoneNumber" placeholder="请输入您的电话号码"></el-input>
            </el-form-item>
            <!--<el-form-item label="微信号">
              <el-input v-model="baseInfo.wechat" placeholder="请输入您的微信号"></el-input>
            </el-form-item>-->
            <el-form-item label="邮箱">
              <el-input v-model="baseInfo.email" placeholder="请输入您的邮箱"></el-input>
            </el-form-item>
          </el-form>
          <div style="text-align: right">
            <el-button size="small" @click="editCancel">取消</el-button>
            <el-button size="small" type="primary" @click="editBaseInfo">完成</el-button>
          </div>
        </div>
        <el-divider></el-divider>

<!--        个人优势-->
        <div class="personal-advantage" v-if="!baseInfo.isEditAdvantage">
          <div class="personal-info-item-title">个人优势</div>
          <div class="personal-advantage-text-box">
            <div class="personal-advantage-text" @click="baseInfo.isEditAdvantage = true">{{baseInfo.personalAdvantage}}</div>
            <div class="edit" @click="baseInfo.isEditAdvantage = true"><i class="el-icon-edit-outline"></i> 编辑</div>
          </div>
        </div>
        <div class="base-info-edit" v-else>
          <div class="edit-title">编辑个人优势</div>
          <el-form :model="baseInfo" size="small" class="edit-advantage-form">
            <el-form-item>
              <el-input type="textarea"
                        v-model="baseInfo.personalAdvantage"
                        :showWordLimit="true"
                        minlength="2"
                        maxlength="140"
                        placeholder="例如：两年UI设计经验，熟悉IOS和Android的界面设计规范，对产品本色有独特见解，有一定的手绘基础"
                        :autosize="{minRows: 4}"></el-input>
            </el-form-item>
          </el-form>
          <div style="text-align: right">
            <el-button size="small" @click="editCancel()">取消</el-button>
            <el-button size="small" type="primary" @click="editMyIntroduce()">完成</el-button>
          </div>
        </div>
        <el-divider></el-divider>

<!--        期望职位-->
        <div class="wanted-job" v-if="!baseInfo.isEditWantedJobs">
          <div class="personal-info-item-title">期望职位</div>
          <div class="wanted-job-add-item">
            <span class="edit" @click="addWantedJob()"><i class="el-icon-circle-plus-outline"></i> 添加</span>
          </div>
          <div class="wanted-job-content">
            <div class="wanted-job-item" v-for="(item, index) of baseInfo.wantedJobs" :key="index" @click="editWantedJobClickHandle(item)">
              <span class="wanted-job-item-item"><i class="el-icon-medal"></i> {{item.name}}</span>
              <span class="wanted-job-item-item"><i class="el-icon-wallet"></i> {{item['salaryDict']['dictName']}}</span>
              <span class="wanted-job-item-item"><i class="el-icon-postcard"></i> {{item.industry}}</span>
              <span class="wanted-job-item-item"><i class="el-icon-location-information"></i> {{item.city}}</span>
              <div class="wanted-job-item-item-op">
                <span class="wanted-job-item-item-op-delete" @click.stop="deleteWantedJobHandle(item.id)"><i class="el-icon-delete"></i> 删除</span>
                <span class="wanted-job-item-item-op-edit" @click="editWantedJobClickHandle(item)"><i class="el-icon-edit-outline"></i> 编辑</span>
              </div>
            </div>
          </div>
        </div>
        <div class="base-info-edit" v-else>
          <div class="edit-title" v-if="baseInfo.editWantedJob.isAdd">新增期望职位</div>
          <div class="edit-title" v-else>编辑期望职位</div>
          <el-form :inline="true" :model="baseInfo.editWantedJob" size="small" :label-position="'left'" :label-width="'100px'" class="edit-info-form">
            <el-form-item label="期望职位">
              <el-input v-model="baseInfo.editWantedJob.name"></el-input>
            </el-form-item>
            <el-form-item label="薪资要求">
<!--              <el-input v-model="baseInfo.editWantedJob.salary"></el-input>-->
              <el-select v-model="baseInfo.editWantedJob.salary" placeholder="请选择">
                <el-option
                  v-for="item in baseInfo.salaryRangeOption"
                  :key="item['dictNum']"
                  :label="item['dictName']"
                  :value="item['dictNum']">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="行业">
              <el-input v-model="baseInfo.editWantedJob.industry"></el-input>
            </el-form-item>
            <el-form-item label="城市">
              <el-input v-model="baseInfo.editWantedJob.city"></el-input>
            </el-form-item>
          </el-form>
          <div style="text-align: right">
            <el-button size="small" @click="editCancel()">取消</el-button>
            <el-button size="small" type="primary" @click="saveWantedJobHandle()">完成</el-button>
          </div>
        </div>
        <el-divider></el-divider>

<!--        工作经历-->
        <div class="pro-experience" v-if="!baseInfo.isEditWorkExperience">
          <div class="personal-info-item-title">工作经历</div>
          <div class="wanted-job-add-item">
            <span class="edit" @click="addWorkExperienceHandle()"><i class="el-icon-circle-plus-outline"></i> 添加</span>
          </div>
          <div class="pro-experience-content">
            <div class="pro-experience-item" v-for="(item, index) of baseInfo.workExperienceArr" :key="index"  @click="editWorkExperienceHandle(item)">
              <div class="pro-experience-item-item">
                <span class="pro-experience-item-item-title pro-name">{{item.companyName}}</span>
                <span class="pro-time">{{item.workTime[0] | dateFormat("YYYY.MM.DD")}} - {{item.workTime[1] | dateFormat("YYYY.MM.DD")}}</span>
              </div>
              <div class="pro-experience-item-item">
                <span class="pro-experience-item-item-title">{{item.jobName}}</span>
              </div>
              <div class="pro-experience-item-item">
                <span class="pro-experience-item-item-title">内容：</span><span>{{item.jobDetail}}</span>
              </div>
              <div class="pro-experience-item-item" v-if="item.jobAchievement">
                <span class="pro-experience-item-item-title">业绩：</span><span>{{item.jobAchievement}}</span>
              </div>
              <div class="pro-experience-item-item" v-if="item.skillTags">
                <span class="skill-keyword" v-for="(skill, skillIndex) of item.skillTags" :key="skillIndex">{{skill}}</span>
              </div>
              <div class="pro-experience-item-op">
                <span class="pro-experience-item-op-delete" @click.stop="deleteWorkExperience(item.id)"><i class="el-icon-delete"></i> 删除</span>
                <span class="pro-experience-item-op-edit" @click="editProExperienceHandle(item)"><i class="el-icon-edit-outline"></i> 编辑</span>
              </div>
            </div>
          </div>
        </div>
        <div class="base-info-edit" v-else>
          <div class="edit-title" v-if="baseInfo.editWorkExperience.isAdd">新增工作经历</div>
          <div class="edit-title" v-else>编辑工作经历</div>
          <el-form :inline="true" :model="baseInfo.editWorkExperience" size="small" :label-position="'left'" :label-width="'130px'" class="edit-experience-form">
            <el-form-item label="公司名称">
<!--              <el-input v-model="baseInfo.editWorkExperience.companyName"></el-input>-->
              <el-autocomplete
                class="inline-input"
                v-model="baseInfo.editWorkExperience.companyName"
                :fetch-suggestions="queryCompanySearch"
                :trigger-on-focus="false"
                @select="handleSelect"
              ></el-autocomplete>
            </el-form-item>
            <el-form-item label="所属行业">
              <el-input v-model="baseInfo.editWorkExperience.industry"></el-input>
            </el-form-item>
            <el-form-item label="所属部门（选填）">
              <el-input v-model="baseInfo.editWorkExperience.department"></el-input>
            </el-form-item>
            <el-form-item label="职位名称（选填）">
              <el-input v-model="baseInfo.editWorkExperience.jobName"></el-input>
            </el-form-item>
            <el-form-item label="职位类型">
              <el-input v-model="baseInfo.editWorkExperience.jobType"></el-input>
            </el-form-item>
            <el-form-item label="在职时间">
<!--              <el-input v-model="baseInfo.editWorkExperience.workTime"></el-input>-->
              <el-date-picker
                v-model="baseInfo.editWorkExperience.workTime"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-form>
          <el-form :model="baseInfo.editWorkExperience" size="small" :label-position="'top'" :label-width="'130px'" class="edit-experience-form2">
            <el-form-item label="技能标签">
<!--              <el-select-->
<!--                v-model="baseInfo.editWorkExperience.skillTags"-->
<!--                @visible-change="toggleSkillTags"-->
<!--                multiple-->
<!--                filterable-->
<!--                allow-create-->
<!--                default-first-option-->
<!--                placeholder="请选择">-->
<!--                <el-option style="display: none"-->
<!--                  v-for="item in baseInfo.skillOptions"-->
<!--                  :key="item.value"-->
<!--                  :label="item.label"-->
<!--                  :value="item.value">-->
<!--                </el-option>-->
<!--              </el-select>-->
<!--              <div class="skill-tags-template" ref="skillTagsTemplate" v-show="baseInfo.skillTagsTemplateShow">-->
<!--                <div class="skill-tags-template-item" v-for="(tagItem, tagItemIndex) of baseInfo.skillOptions" :key="tagItemIndex" @click="skillTagsChange(tagItem)">-->
<!--                  <span class="keyword" :class="{'match-keyword': baseInfo.editWorkExperience.skillTags.indexOf(tagItem.label) > -1}">{{tagItem.label}}</span>-->
<!--                </div>-->
<!--              </div>-->
              <el-tag
                :key="tag"
                v-for="tag in baseInfo.editWorkExperience.skillTags"
                closable
                size="small"
                :disable-transitions="false"
                style="margin-right: 8px"
                @close="handleSkillTagClose(tag)">
                {{tag}}
              </el-tag>
              <el-input
                class="input-new-tag"
                v-if="inputSkillTagVisible"
                v-model="inputSkillTagValue"
                ref="saveTagInput"
                size="mini"
                @keyup.enter.native="handleInputSkillTagConfirm"
                @blur="handleInputSkillTagConfirm"
              >
              </el-input>
              <el-button v-else class="button-new-tag" size="mini" @click="showInput">+ 添加</el-button>
            </el-form-item>
            <el-form-item label="工作内容">
              <el-input v-model="baseInfo.editWorkExperience.jobDetail"
                        type="textarea"
                        :showWordLimit="true"
                        minlength="2"
                        maxlength="1000"
                        placeholder="请输入内容"
                        :autosize="{minRows: 4}"></el-input>
            </el-form-item>
            <el-form-item label="工作业绩（选填）">
              <el-input v-model="baseInfo.editWorkExperience.jobAchievement"
                        type="textarea"
                        :showWordLimit="true"
                        minlength="0"
                        maxlength="300"
                        placeholder="请输入内容"
                        :autosize="{minRows: 4}"></el-input>
            </el-form-item>
          </el-form>
          <div style="text-align: right">
            <el-button size="small" @click="editCancel()">取消</el-button>
            <el-button size="small" type="primary" @click="saveWorkExperience()">完成</el-button>
          </div>
        </div>
        <el-divider></el-divider>

<!--        项目经历 暂时隐藏-->
        <div class="pro-experience" v-if="false">
          <div class="personal-info-item-title">项目经历</div>
          <div class="wanted-job-add-item">
            <span class="edit" @click="addProExperienceHandle()"><i class="el-icon-circle-plus-outline"></i> 添加</span>
          </div>
          <div class="pro-experience-content">
            <div class="pro-experience-item" v-for="(item, index) of baseInfo.proExperienceArr" :key="index"  @click="editProExperienceHandle(item)">
              <div class="pro-experience-item-item">
                <span class="pro-experience-item-item-title pro-name">{{item.proName}}</span>
                <span class="pro-time">{{item.proTime}}</span>
              </div>
              <div class="pro-experience-item-item">
                <span class="pro-experience-item-item-title">{{item.name}}</span>
              </div>
              <div class="pro-experience-item-item">
                <span class="pro-experience-item-item-title">内容：</span><span>{{item.proDes}}</span>
              </div>
              <div class="pro-experience-item-item" v-if="item.proAchievement">
                <span class="pro-experience-item-item-title">业绩：</span><span>{{item.proAchievement}}</span>
              </div>
              <div class="pro-experience-item-item" v-if="item.proURL">
                <span class="pro-experience-item-item-title">项目链接：</span><span>{{item.proURL}}</span>
              </div>
              <div class="pro-experience-item-op">
                <span class="pro-experience-item-op-delete"><i class="el-icon-delete"></i> 删除</span>
                <span class="pro-experience-item-op-edit" @click="editProExperienceHandle(item)"><i class="el-icon-edit-outline"></i> 编辑</span>
              </div>
            </div>
          </div>
        </div>
        <div class="base-info-edit" v-if="false">
          <div class="edit-title" v-if="baseInfo.editProExperience.isAdd">新增项目经历</div>
          <div class="edit-title" v-else>编辑项目经历</div>
          <el-form :inline="true" :model="baseInfo.editProExperience" size="small" :label-position="'left'" :label-width="'130px'" class="edit-experience-form">
            <el-form-item label="项目名称">
              <el-input v-model="baseInfo.editProExperience.proName"></el-input>
            </el-form-item>
            <el-form-item label="项目角色">
              <el-input v-model="baseInfo.editProExperience.name"></el-input>
            </el-form-item>
            <el-form-item label="项目参与时间">
              <el-input v-model="baseInfo.editProExperience.proTime"></el-input>
            </el-form-item>
            <el-form-item label="项目链接（选填）">
              <el-input v-model="baseInfo.editProExperience.proURL"></el-input>
            </el-form-item>
          </el-form>
          <el-form :model="baseInfo.editProExperience" size="small" :label-position="'top'" :label-width="'130px'" class="edit-experience-form2">
            <el-form-item label="项目描述">
              <el-input v-model="baseInfo.editProExperience.proDes"
                        type="textarea"
                        :showWordLimit="true"
                        minlength="2"
                        maxlength="1000"
                        placeholder="请输入内容"
                        :autosize="{minRows: 4}"></el-input>
            </el-form-item>
            <el-form-item label="项目业绩（选填）">
              <el-input v-model="baseInfo.editProExperience.proAchievement"
                        type="textarea"
                        :showWordLimit="true"
                        minlength="0"
                        maxlength="300"
                        placeholder="请输入内容"
                        :autosize="{minRows: 4}"></el-input>
            </el-form-item>
          </el-form>
          <div style="text-align: right">
            <el-button size="small" @click="cancelEditProExperience()">取消</el-button>
            <el-button size="small" type="primary" @click="baseInfo.isEditProExperience = false">完成</el-button>
          </div>
        </div>
<!--        <el-divider></el-divider>-->

<!--        教育经历-->
        <div class="pro-experience" v-if="!baseInfo.isEditEducation">
          <div class="personal-info-item-title">教育经历</div>
          <div class="wanted-job-add-item">
            <span class="edit" @click="addEducationHandle()"><i class="el-icon-circle-plus-outline"></i> 添加</span>
          </div>
          <div class="pro-experience-content">
            <div class="pro-experience-item" v-for="(item, index) of baseInfo.educationArr" :key="index"  @click="editEducationHandle(item)">
              <div class="pro-experience-item-item">
                <span class="pro-experience-item-item-title pro-name">{{item.schoolName}}</span>
                <span class="pro-time">{{item.educationTime[0] | dateFormat('YYYY.MM.DD')}} - {{item.educationTime[1] | dateFormat('YYYY.MM.DD')}}</span>
              </div>
              <div class="pro-experience-item-item">
                <span class="pro-experience-item-item-title">{{item.major}}</span>
                <span class="pro-experience-item-item-title education-type">{{item.educationType}}</span>
              </div>
              <div class="pro-experience-item-item">
                <span>{{item.experience}}</span>
              </div>
              <div class="pro-experience-item-op">
                <span class="pro-experience-item-op-delete" @click.stop="educationExperienceDeleteHandle(item.id)"><i class="el-icon-delete"></i> 删除</span>
                <span class="pro-experience-item-op-edit" @click="editEducationHandle(item)"><i class="el-icon-edit-outline"></i> 编辑</span>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="edit-title" v-if="baseInfo.editEducation.isAdd">添加教育经历</div>
          <div class="edit-title" v-else>编辑教育经历</div>
          <el-form :inline="true" :model="baseInfo.editEducation" size="small" :label-position="'left'" :label-width="'130px'" class="edit-experience-form">
            <el-form-item label="学校名称">
              <el-input v-model="baseInfo.editEducation.schoolName"></el-input>
            </el-form-item>
            <el-form-item label="日制类型">
<!--              <el-input v-model="baseInfo.editEducation.schoolType"></el-input>-->
              <el-select v-model="baseInfo.editEducation.schoolType" placeholder="请选择">
                <el-option
                  v-for="item in [{value: '全日制', label: '全日制'}, {value: '非全日制', label: '非全日制'}]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="学历">
<!--              <el-input v-model="baseInfo.editEducation.educationType"></el-input>-->
              <el-select v-model="baseInfo.editEducation.educationType" placeholder="请选择">
                <el-option
                  v-for="item in [{value: '初中及以下', label: '初中及以下'},
                  {value: '中专/中技', label: '中专/中技'},
                  {value: '高中', label: '高中'},
                  {value: '大专', label: '大专'},
                  {value: '本科', label: '本科'},
                  {value: '硕士', label: '硕士'},
                  {value: '博士', label: '博士'}]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="专业">
              <el-input v-model="baseInfo.editEducation.major"></el-input>
            </el-form-item>
<!--            <el-form-item label="入学时间">-->
<!--              <el-input v-model="baseInfo.editEducation.educationTime[0]"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="毕业时间">-->
<!--              <el-input v-model="baseInfo.editEducation.educationTime[1]"></el-input>-->
<!--            </el-form-item>-->
            <el-form-item label="在校时间">
              <el-date-picker
                v-model="baseInfo.editEducation.educationTime"
                type="daterange"
                range-separator="至"
                start-placeholder="入学日期"
                end-placeholder="毕业日期">
              </el-date-picker>
            </el-form-item>
          </el-form>
          <el-form :model="baseInfo.editEducation" size="small" :label-position="'top'" :label-width="'130px'" class="edit-experience-form2">
            <el-form-item label="在校经历（选填）">
              <el-input v-model="baseInfo.editEducation.experience"
                        type="textarea"
                        :showWordLimit="true"
                        maxlength="300"
                        placeholder="请填写内容"
                        :autosize="{minRows: 4}"></el-input>
            </el-form-item>
          </el-form>
          <div style="text-align: right">
            <el-button size="small" @click="editCancel()">取消</el-button>
            <el-button size="small" type="primary" @click="educationExperienceSaveHandle()">完成</el-button>
          </div>
        </div>
        <el-divider></el-divider>

      </div>
    </div>
</template>

<script>
import utilService from '../../utils/utilService'
export default {
  name: 'Resume',
  data () {
    return {
      baseInfo: {
        id: '',
        isEditBaseInfo: false,
        name: '',
        sex: '',
        workExperience: 0,
        phoneNumber: '',
        wechat: '',
        email: '',
        workState: '',
        education: '',
        updateDate: new Date().getTime(),
        isEditAdvantage: false,
        personalAdvantage: '',
        personalAdvantageTmp: '',
        isEditWantedJobs: false,
        wantedJobs: [],
        editWantedJob: null,
        salaryRangeOption: [],
        isEditWorkExperience: false,
        workExperienceArr: [],
        editWorkExperience: null,
        isEditProExperience: false,
        proExperienceArr: [
          {
            name: 'JAVA开发',
            proName: '华为NetEco',
            proTime: '2016.3-2018.5',
            proDes: 'iManager NetEco6000 为数据中心基础设施提供...',
            proAchievement: '2016届优秀实习生，2017年优秀员工',
            proURL: ''
          },
          {
            name: 'web前端开发',
            proName: '华为智能服务器',
            proTime: '2018.9-2018.11',
            proDes: '华为IT产品线智能服务器...',
            proAchievement: '2018最佳新员工成长，2018年底季度高绩效奖',
            proURL: ''
          }
        ],
        editProExperience: null,
        isEditEducation: false,
        educationArr: [],
        editEducation: null,
        skillOptions: [
          {value: 'JavaScript', label: 'JavaScript'},
          {value: 'HTML/CSS', label: 'HTML/CSS'},
          {value: 'Vue', label: 'Vue'},
          {value: 'Angular', label: 'Angular'},
          {value: 'React', label: 'React'},
          {value: 'CSS', label: 'CSS'},
          {value: 'bootstrap', label: 'bootstrap'},
          {value: 'AngularJS', label: 'AngularJS'},
          {value: 'jquery', label: 'jquery'},
          {value: 'Zepto', label: 'Zepto'},
          {value: 'node.js', label: 'node.js'},
          {value: 'Less', label: 'Less'},
          {value: 'typescript', label: 'typescript'},
          {value: 'redux', label: 'redux'},
          {value: 'Backbone', label: 'Backbone'},
          {value: 'ajax', label: 'ajax'},
          {value: 'JSON', label: 'JSON'},
          {value: 'XML', label: 'XML'}
        ],
        skillTagsTemplateShow: false
      },
      inputSkillTagVisible: false,
      inputSkillTagValue: ''
    }
  },
  methods: {
    addWantedJob () {
      let newItem = {
        isAdd: true,
        name: '',
        salary: '',
        industry: '',
        city: ''
      }
      this.baseInfo.wantedJobs.push(newItem)
      this.editWantedJobClickHandle(newItem)
    },
    editWantedJobClickHandle (item) {
      this.baseInfo.isEditWantedJobs = true
      this.baseInfo.editWantedJob = item
    },
    saveWantedJobHandle () {
      let param = {
        desiredPosition: this.baseInfo.editWantedJob.name,
        salary: this.baseInfo.editWantedJob.salary,
        profession: this.baseInfo.editWantedJob.industry,
        city: this.baseInfo.editWantedJob.city
      }

      if (this.baseInfo.editWantedJob.isAdd) {
        this.$http.post(this.$api.desirePositionSave.url, param).then(_ => {
          if (_ && _.code && _.data) {
            this.$message.success('新增期望职位成功！')
            this.baseInfo.editWantedJob.salaryDict = _.data.salaryDict
            delete this.baseInfo.editWantedJob.isAdd
            // this.baseInfo.isEditWantedJobs = false
            this.editCancel()
          } else {
            this.$message.error('新增失败！')
          }
        })
      } else {
        param.id = this.baseInfo.editWantedJob.id
        this.$http.put(this.$api.desirePositionEdit.url, param).then(_ => {
          if (_ && _.code && _.data) {
            this.$message.success('期望职位编辑成功！')
            this.baseInfo.editWantedJob.salaryDict = _.data.salaryDict
            // this.baseInfo.isEditWantedJobs = false
            this.editCancel()
          } else {
            this.$message.error('编辑失败！')
          }
        })
      }
    },
    deleteWantedJobHandle (id) {
      this.$confirm('是否删除该期望职位?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.$http.delete(this.$api.desirePositionDelete.url, {
          id
        }).then(_ => {
          if (_ && _.code === 200) {
            this.baseInfo.wantedJobs = this.baseInfo.wantedJobs.filter(item => item.id !== id)
            this.$message.success('删除期望职位成功！')
          }
        })
      })
    },
    cancelEditWantedJob () {
      if (this.baseInfo.wantedJobs[this.baseInfo.wantedJobs.length - 1].isAdd) {
        this.baseInfo.wantedJobs.pop()
      }
      this.baseInfo.isEditWantedJobs = false
    },
    addProExperienceHandle () {
      let newItem = {
        isAdd: true,
        name: '',
        proName: '',
        proTime: [],
        proDes: '',
        proAchievement: '',
        proURL: ''
      }
      this.baseInfo.proExperienceArr.push(newItem)
      this.editProExperienceHandle(newItem)
    },
    editProExperienceHandle (item) {
      this.baseInfo.isEditProExperience = true
      this.baseInfo.editProExperience = item
    },
    cancelEditProExperience () {
      if (this.baseInfo.proExperienceArr[this.baseInfo.proExperienceArr.length - 1].isAdd) {
        this.baseInfo.proExperienceArr.pop()
      }
      this.baseInfo.isEditProExperience = false
    },
    addWorkExperienceHandle () {
      let newItem = {
        isAdd: true,
        companyCode: '',
        companyName: '',
        industry: '',
        department: '',
        jobName: '',
        jobType: '',
        workTime: '',
        skillTags: [],
        jobDetail: '',
        jobAchievement: ''
      }
      this.baseInfo.workExperienceArr.push(newItem)
      this.editWorkExperienceHandle(newItem)
    },
    editWorkExperienceHandle (item) {
      this.baseInfo.isEditWorkExperience = true
      this.baseInfo.editWorkExperience = item
    },
    cancelEditWorkExperience () {
      if (this.baseInfo.workExperienceArr[this.baseInfo.workExperienceArr.length - 1].isAdd) {
        this.baseInfo.workExperienceArr.pop()
      }
      this.baseInfo.editWorkExperience = null
      this.baseInfo.isEditWorkExperience = false
    },
    addEducationHandle () {
      let newItem = {
        isAdd: true,
        schoolName: '',
        schoolType: '',
        educationType: '',
        major: '',
        educationTime: ['', ''],
        experience: ''
      }
      this.baseInfo.educationArr.push(newItem)
      this.editEducationHandle(newItem)
    },
    editEducationHandle (item) {
      this.baseInfo.isEditEducation = true
      this.baseInfo.editEducation = item
    },
    educationExperienceSaveHandle () {
      let param = {
        schoolName: this.baseInfo.editEducation.schoolName,
        category: this.baseInfo.editEducation.schoolType,
        major: this.baseInfo.editEducation.major,
        experience: this.baseInfo.editEducation.educationType,
        startTime: new Date(this.baseInfo.editEducation.educationTime[0]).getTime(),
        endTime: new Date(this.baseInfo.editEducation.educationTime[1]).getTime(),
        associationActivity: this.baseInfo.editEducation.experience
      }

      if (this.baseInfo.editEducation.isAdd) {
        this.$http.post(this.$api.educationExperienceSave.url, param).then(_ => {
          if (_ && _.code === 200 && _.data) {
            this.baseInfo.editEducation.id = _.data.id
            delete this.baseInfo.editEducation.isAdd
            this.$message.success('新增教育经历成功！')
            // this.baseInfo.isEditEducation = false
            this.editCancel()
          } else {
            this.$message.error('新增教育经历失败！')
          }
        })
      } else {
        param.id = this.baseInfo.editEducation.id
        this.$http.put(this.$api.educationExperienceEdit.url, param).then(_ => {
          if (_ && _.code === 200 && _.data) {
            this.$message.success('修改教育经历成功！')
            // this.baseInfo.isEditEducation = false
            this.editCancel()
          } else {
            this.$message.success('修改教育经历失败！')
          }
        })
      }
    },
    educationExperienceDeleteHandle (id) {
      this.$confirm('是否删除该教育经历?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.$http.delete(this.$api.educationExperienceDelete.url, {
          id
        }).then(_ => {
          if (_ && _.code === 200) {
            this.baseInfo.educationArr = this.baseInfo.educationArr.filter(item => item.id !== id)
            this.$message.success('删除教育经历成功！')
          }
        })
      })
    },
    cancelEditEducation () {
      if (this.baseInfo.educationArr[this.baseInfo.educationArr.length - 1].isAdd) {
        this.baseInfo.educationArr.pop()
      }
      this.baseInfo.isEditEducation = false
    },
    toggleSkillTags (toggleFlag) {
      this.baseInfo.skillTagsTemplateShow = toggleFlag
    },
    skillTagsChange (tagItem) {
      if (this.baseInfo.editWorkExperience.skillTags.indexOf(tagItem.label) > -1) {
        this.baseInfo.editWorkExperience.skillTags.splice(this.baseInfo.editWorkExperience.skillTags.indexOf(tagItem.label), 1)
      } else {
        this.baseInfo.editWorkExperience.skillTags.push(tagItem.label)
      }
    },
    getCurrentUsrResume () {
      this.$http.get(this.$api.getCurrentUsrResume.url).then(_ => {
        if (_ && _.code === 200 && _.data) {
          this.baseInfo.id = _.data.id
          this.baseInfo.resumePojo = _.data.resumePojo || null
          this.baseInfo.name = _.data.realName || _.data.userName
          this.baseInfo.sex = _.data.sex
          this.baseInfo.updateDate = _.data.updateDate
          this.baseInfo.workExperience = _.data.resumePojo ? _.data.resumePojo.workingLife / 10 : 0
          this.baseInfo.workState = _.data.resumePojo ? _.data.resumePojo.jobStatus || '--' : '--'
          this.baseInfo.phoneNumber = _.data.resumePojo ? _.data.resumePojo.phone || '--' : '--'
          this.baseInfo.email = _.data.resumePojo ? _.data.resumePojo.email || '--' : '--'
          this.baseInfo.education = _.data.resumePojo ? _.data.resumePojo.education || '--' : '--'
          this.baseInfo.personalAdvantage = _.data.resumePojo ? _.data.resumePojo.introduce || '--' : '--'
          this.baseInfo.personalAdvantageTmp = this.baseInfo.personalAdvantage
          this.baseInfo.wantedJobs = _.data['listDesiredPosition'] ? _.data['listDesiredPosition'].map(item => {
            return {
              id: item.id,
              name: item.desiredPosition,
              salary: item['salaryDict']['dictNum'],
              salaryDict: item['salaryDict'],
              industry: item.profession,
              city: item.city
            }
          }) : []

          this.baseInfo.workExperienceArr = _.data['listJobExperiences'] ? _.data['listJobExperiences'].map(item => {
            return {
              id: item.id,
              companyCode: item.companyCode,
              companyName: item.companyName,
              industry: item.profession,
              department: item.department,
              jobName: item.professionName,
              jobType: item.professionCategory,
              workTime: [item.startTime, item.endTime],
              skillTags: item.listLabel.map(tagItem => tagItem.labelName),
              jobDetail: item.content,
              jobAchievement: item.achievement
            }
          }) : []

          this.baseInfo.educationArr = _.data['listEducationExperience'] ? _.data['listEducationExperience'].map(item => {
            return {
              id: item.id,
              schoolName: item.schoolName,
              schoolType: item.category,
              educationType: item.experience,
              major: item.major,
              educationTime: [item.startTime, item.endTime],
              experience: item.associationActivity
            }
          }) : []
        }
      })
    },
    downloadMyResume () {
      this.$http.get(this.$api.getUsrResume.url, {
        userCode: this.$store.get('user').userCode
      }).then(_ => {
        utilService.downloadFileForStream(_, `个人简历_${this.$store.get('user').realName || this.$store.get('user').userName}.doc`, 'application/msword')
      })
      // let url = location.origin + '/recurit/user/downloadResume'
      // window.open(url, '_blank')
    },
    queryCompanySearch (queryString, cb) {
      this.$http.get(this.$api.queryCompanyByName.url, {
        companyName: queryString.trim().toLowerCase()
      }).then(_ => {
        if (_ && _.code === 200 && _.data) {
          console.log(_)
          let res = _.data.map(item => {
            return {
              value: item.companyName,
              companyCode: item.companyCode
            }
          })
          cb(res)
        } else {
          // eslint-disable-next-line standard/no-callback-literal
          cb([])
        }
      })
    },
    handleSelect (item) {
      console.log(item)
      this.baseInfo.workExperienceArr.filter(item => item.isAdd)[0].companyCode = item.companyCode
      console.log(this.baseInfo.workExperienceArr)
    },
    handleSkillTagClose (tag) {
      this.baseInfo.editWorkExperience.skillTags.splice(this.baseInfo.editWorkExperience.skillTags.indexOf(tag), 1)
    },
    showInput () {
      this.inputSkillTagVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleInputSkillTagConfirm () {
      let inputValue = this.inputSkillTagValue.trim()
      if (this.baseInfo.editWorkExperience.skillTags.indexOf(inputValue) > -1) {
        this.$alert('技能标签已存在')
        return false
      }

      if (this.baseInfo.editWorkExperience.skillTags.length === 4 && inputValue) {
        this.$alert('最多只允许添加4个技能标签')
        return false
      }

      if (inputValue) {
        this.baseInfo.editWorkExperience.skillTags.push(inputValue)
      }
      this.inputSkillTagVisible = false
      this.inputSkillTagValue = ''
    },
    saveWorkExperience () {
      let newEx = this.baseInfo.editWorkExperience
      console.log(newEx)
      let param = {
        companyCode: newEx.companyCode,
        profession: newEx.industry,
        department: newEx.department,
        professionName: newEx.jobName,
        professionCategory: newEx.jobType,
        startTime: new Date(newEx.workTime[0]).getTime(),
        endTime: new Date(newEx.workTime[1]).getTime(),
        labels: newEx.skillTags.join(','),
        content: newEx.jobDetail,
        achievement: newEx.jobAchievement
      }
      console.log(param)
      if (newEx.isAdd) {
        this.$http.post(this.$api.saveNewWorkExperience.url, param).then(_ => {
          if (_ && _.code === 200 && _.data) {
            this.baseInfo.editWorkExperience.id = _.data.id
            this.baseInfo.editWorkExperience = null
            // this.baseInfo.isEditWorkExperience = false
            this.$message.success('个人工作经历添加成功！')
            this.editCancel()
          }
        })
      } else {
        param['id'] = this.baseInfo.editWorkExperience.id
        this.$http.put(this.$api.editWorkExperience.url, param).then(_ => {
          if (_ && _.code === 200 && _.data) {
            this.baseInfo.editWorkExperience = null
            // this.baseInfo.isEditWorkExperience = false
            this.$message.success('个人工作经历修改成功！')
            this.editCancel()
          }
        })
      }
    },
    deleteWorkExperience (id) {
      this.$confirm('是否删除该工作经历?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.$http.delete(this.$api.deleteWorkExperience.url, {
          id
        }).then(_ => {
          if (_ && _.code === 200) {
            this.baseInfo.workExperienceArr = this.baseInfo.workExperienceArr.filter(item => item.id !== id)
            this.$message.success('删除个人工作经历成功！')
          }
        })
      })
    },
    editBaseInfo () {
      this.$http.put(this.$api.editMyResumeBaseInfo.url, {
        id: this.baseInfo.resumePojo.id,
        jobStatus: this.baseInfo.workState,
        workingLife: this.baseInfo.workExperience * 10,
        phone: this.baseInfo.phoneNumber,
        email: this.baseInfo.email
      }).then(_ => {
        if (_ && _.code === 200) {
          this.$message.success('个人信息更新成功！')
          // this.baseInfo.isEditBaseInfo = false
          this.editCancel()
        } else {
          this.$message.error('个人信息更新失败！')
        }
      })
    },
    // 编辑个人优势
    editMyIntroduce () {
      this.$http.put(this.$api.editMyResumeBaseInfo.url, {
        id: this.baseInfo.resumePojo.id,
        introduce: this.baseInfo.personalAdvantage
      }).then(_ => {
        if (_ && _.code === 200) {
          this.$message.success('个人优势更新成功！')
          // this.baseInfo.isEditAdvantage = false
          this.editCancel()
        } else {
          this.$message.error('个人优势更新失败！')
        }
      })
    },
    editMyIntroduceCancel () {
      this.baseInfo.personalAdvantage = this.baseInfo.personalAdvantageTmp
      this.baseInfo.isEditAdvantage = false
    },
    editCancel () {
      this.baseInfo.isEditBaseInfo = false
      this.baseInfo.isEditAdvantage = false
      this.baseInfo.isEditWantedJobs = false
      this.baseInfo.isEditWorkExperience = false
      this.baseInfo.isEditEducation = false
      this.getCurrentUsrResume()
    }
  },
  mounted () {
    this.getCurrentUsrResume()

    // 薪资下拉框回显数据
    this.$http.get(this.$api.getAllDictByCategory.url, {
      category: 'SALARY'
    }).then(_ => {
      if (_ && _.code === 200) {
        this.baseInfo.salaryRangeOption = _.data
      }
    })
  }
}
</script>

<style scoped>
.resume {
  width: 1200px;
  text-align: left;
  margin: auto;
  /*min-height: calc(100vh - 60px);*/
  /*background: #fff;*/
}
  .resume-info-content-box {
    padding: 30px;
    background: #fff;
    margin-top: 20px;
  }
  .resume-header {
    color: #666666;
    padding-bottom: 10px;
  }
  .edit {
    cursor: pointer;
    position: absolute;
    right: 10px;
    bottom: 0;
    color: #409eff;
  }
  .edit:hover, .wanted-job-item-item-op-delete:hover, .wanted-job-item-item-op-edit:hover,
  .pro-experience-item-op-delete:hover, .pro-experience-item-op-edit:hover {
    text-shadow: 2px 2px 2px #cccccc;
  }
  .base-info {
    position: relative;
  }
  .user-name {
    font-size: 24px;
    font-weight: 400;
    margin-bottom: 20px;
  }
  .el-icon-male {
    font-size: 20px;
    font-weight: bolder;
    color: #409EFF;
  }
.el-icon-female {
  font-size: 20px;
  font-weight: bolder;
  color: deeppink;
}
  .line-divide {
    position: relative;
    margin-left: 50px;
  }
  .line-divide::before, .wanted-job-item > .wanted-job-item-item:not(:first-child)::before {
    position: absolute;
    content: '';
    width: 1px;
    height: 12px;
    background: #cccccc;
    left: -26px;
    top:2px
  }
  .edit-title {
    font-size: 16px;
    font-weight: 500;
    color: #24272e;
    margin-bottom: 20px;
  }
.el-form--inline .el-form-item {
  width: calc(50% - 2px);
  margin-right: 0;
}
/deep/ .edit-info-form > .el-form-item:nth-of-type(even) > label, /deep/ .edit-experience-form > .el-form-item:nth-of-type(even) > label {
  margin-left: 50px;
}
  .base-info-edit {
    padding: 20px 30px;
    background: #f8f9fb;
  }
  /deep/ .el-form-item__content {
    width: calc(100% - 150px);
  }
/deep/ .edit-experience-form .el-form-item__content {
  width: calc(100% - 180px);
}
/deep/ .el-select {
  width: 100%;
}
  .btn-checked {
    color: #3a8ee6;
    border-color: #3a8ee6;
    outline: 0;
    background-color: #ecf5ff;
  }
  .personal-info-item-title {
    position: relative;
    padding-left: 12px;
    font-size: 18px;
    font-weight: 400;
  }
  .personal-info-item-title::before {
    content: "";
    position: absolute;
    width: 3px;
    height: 14px;
    border-radius: 10px;
    background-color: #409EFF;
    left: 0;
    top: 5px;
  }
  .personal-advantage-text-box {
    position: relative;
  }
  .personal-advantage-text-box:hover, .wanted-job-item:hover, .pro-experience-item:hover {
    background-color: #f2f5f9;
    cursor: pointer;
  }
  .personal-advantage-text {
    padding: 20px;
    margin-right: 70px;
  }
  /deep/ .edit-advantage-form .el-form-item__content {
    width: 100%;
  }
  .wanted-job-content, .pro-experience-content {
    margin-top: 10px;
  }
  .wanted-job-item {
    position: relative;
    line-height: 40px;
    padding-left: 12px;
  }
  .wanted-job-item > .wanted-job-item-item:not(:first-child) {
    position: relative;
    margin-left: 50px;
  }
  .wanted-job-item-item-op, .pro-experience-item-op {
    position: absolute;
    right: 10px;
    top: 0;
    color: #409EFF;
    display: none;
  }
  .pro-experience-item-op {
    top: 10px;
  }
  .wanted-job-item:hover > .wanted-job-item-item-op, .pro-experience-item:hover > .pro-experience-item-op {
    display: block;
  }
  .wanted-job-item-item-op-edit {
    margin-left: 8px;
  }
  .wanted-job, .wanted-job-add-item {
    position: relative;
  }
  .pro-experience-item {
    position: relative;
    padding: 10px 12px;
  }
  .pro-experience-item-item {
    margin-top: 10px;
    color: #61687c;
  }
  .pro-experience-item > .pro-experience-item-item:first-child {
    margin-top: 0;
    margin-bottom: 20px;
  }
  .pro-experience-item-item-title {
    color: #61687c;
    font-weight: 700;
  }
.pro-name {
  font-size: 15px;
  font-weight: 700;
  color: #414a60;
}
.pro-time {
  font-size: 12px;
  padding-left: 30px;
  color: #9fa3b0;
}
  /deep/ .edit-experience-form2 .el-form-item__content {
    width: 100%;
  }
  .skill-keyword {
    display: inline-block;
    font-size: 12px;
    line-height: 20px;
    color: #9fa3b0;
    padding: 0 14px;
    margin-right: 10px;
    border: 1px solid #cfd1d7;
    border-radius: 50px;
  }
  .skill-tags-template {
    position: absolute;
    z-index: 9999999;
    padding: 0 10px;
    background: #ffffff;
    box-shadow: 0 1px 6px rgba(0,0,0,.1);
  }
  .skill-tags-template-item {
    display: inline-block;
    width: 16.66666%;
    font-size: 12px;
    color: #414a60;
  }
  .skill-tags-template-item:hover {
    cursor: pointer;
  }
  .keyword {
    display: inline-block;
    border: 1px solid transparent;
    border-radius: 50px;
    padding: 0 15px;
    line-height: 20px;
    height: 20px;
  }
  .keyword:hover {
    background-color: #f2f5fa;
    border-color: #f2f5fa;
  }
  .match-keyword {
    color: #409EFF;
    border-color: #409EFF;
  }
  .match-keyword:hover {
    background-color: #ffffff;
    color: #409EFF;
    border-color: #409EFF;
  }
  .education-type {
    position: relative;
    margin-left: 50px;
  }
  .education-type::before {
    position: absolute;
    content: '';
    width: 1px;
    height: 12px;
    background: #cccccc;
    left: -26px;
    top:2px
  }
.download-resume {
  color: #409EFF;
  margin-left: 20px;
  cursor: pointer;
}
.download-resume:hover {
  text-decoration: underline;
}
/deep/ .el-range-editor--small.el-input__inner, /deep/ .el-autocomplete, /deep/ .el-input-number--small {
   width: 100%;
 }
  /deep/ .input-new-tag {
    width: 150px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Resume/Resume.vue